export default __webpack_public_path__ + "static/media/IMG_9018.3743a3a2.webp";